<template>
    <RefsPanel/>
</template>

<script>
import RefsPanel from './RefsPanel'
export default {
    name: 'Campaigns',
    components: {
        RefsPanel
    }
}
</script>

<style>

</style>